import { Network } from "lucide-react";
import { PALETTE, BG_PALETTE } from "../lib/theme";
import type { Section3b } from "../lib/types";

const C = PALETTE[3];
const BG = BG_PALETTE[3];

interface Props {
  data: Section3b;
}

export function SectionInterdependances({ data }: Props) {
  return (
    <div className="flex flex-col gap-4">
      {data.paires.map((paire, i) => (
        <div
          key={`pair-${i}`}
          className="overflow-hidden rounded-2xl bg-white"
          style={{ border: `1.5px solid ${C}33` }}
        >
          <div
            className="flex items-center gap-2 px-3.5 py-2.5"
            style={{ background: BG, borderBottom: `1px solid ${C}22` }}
          >
            <Network size={14} color={C} strokeWidth={2} />
            <span
              className="text-[11px] font-bold uppercase tracking-wide"
              style={{ color: C }}
            >
              {paire.activite_source}
            </span>
          </div>
          <div className="divide-y divide-slate-100">
            {paire.complementaires.map((comp, j) => (
              <div
                key={`comp-${j}`}
                className="px-3.5 py-3"
                style={{ background: j % 2 === 0 ? "#fff" : "#fafafa" }}
              >
                <div className="flex items-center gap-2">
                  <span
                    className="block h-1.5 w-1.5 shrink-0 rounded-full"
                    style={{ background: C }}
                  />
                  <span className="text-sm font-semibold text-slate-800">
                    {comp.activite}
                  </span>
                </div>
                <p className="mt-1 pl-3.5 text-xs leading-relaxed text-slate-500">
                  {comp.justification}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
